const state = localStorage.getItem("user-token")
  ? {
      loggedIn: true,
      token: localStorage.getItem("user-token"),
      //@ts-ignore
      details: JSON.parse(localStorage.getItem("user-details") || "{}"),
      //@ts-ignore

      permissions: JSON.parse(localStorage.getItem("permissions") || "[]"),
    }
  : {
      loggedIn: false,
      token: null,
      permissions: [],
      details: {},
    }

export default {
  ...state,
}
